export interface DatePickerTranslations {
  invalidDate: string;
}

export const datePickerTranslationKeys: DatePickerTranslations = {
  invalidDate: 'invalidDate',
};

export const datePickerTranslationsEN: DatePickerTranslations = {
  invalidDate: 'Invalid Date Entered',
};

export const datePickerTranslationsES: DatePickerTranslations = {
  invalidDate: 'Fecha ingresada no válida',
};
